<template>
  <table-pagination-v2
    :current-page="currentPage"
    :total-pages="totalPages"
    :total-items="meta.totalEntries"
    :page-size="meta.perPage"
    :is-r-t-l="isRTLView"
    @page-change="onPageChange"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import TablePaginationV2 from 'v2/components/Table/TablePaginationV2.vue';
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  components: { TablePaginationV2 },
  mixins: [rtlMixin],
  props: {
    onPageChange: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      meta: 'auditlogs/getMeta',
    }),
    currentPage() {
      return Number(this.meta.currentPage) || 1;
    },
    totalPages() {
      return Math.ceil(this.meta.totalEntries / this.meta.perPage) || 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.current-page {
  @apply bg-green-500 text-white;
}

.paginate-btn-without-hover {
  @apply rounded-[8px] flex flex-col justify-center items-center cursor-default;
  @apply bg-white border border-[#F5F5F5] text-[#525252];
  @apply focus:bg-white focus:border-[#F5F5F5] focus:text-[#525252];
  @apply hover:bg-white hover:border-[#F5F5F5] hover:text-[#525252];
}

.paginate-btn {
  @apply rounded-[8px] flex flex-col justify-center items-center;
  @apply bg-white border border-[#F5F5F5] text-[#525252];
  @apply focus:bg-white focus:border-[#F5F5F5] focus:text-[#525252];
  @apply hover:bg-white hover:border-[#4BCE97] hover:text-[#216E4E];

  &.current-page {
    @apply bg-green-500 border-green-500 text-white;
  }

  &.disabled {
    @apply bg-[#F5F5F5] opacity-100 text-[#A3A3A3];
    @apply focus:bg-[#F5F5F5] focus:border-[#F5F5F5] focus:text-[#A3A3A3];
    @apply hover:bg-[#F5F5F5] hover:border-[#F5F5F5] hover:text-[#A3A3A3];
  }
}
</style>
